export default {
  velt: {
    openPanel: 'Otwórz panel komentarzy',
    closePanel: 'Zamknij panel komentarzy',
    panel: 'Panel komentarzy',
    tabs: 'Karty panelu komentarzy',
    comments: 'Komentarze',
    settings: 'Ustawienia i uprawnienia',
    dragOrTapComment: 'Przeciągnij, aby dodać komentarz, lub stuknij, aby wyświetlić komentarze',
    assignComment: 'Przypisz komentarz',
    markAsUnread: 'Oznacz jako nieprzeczytane',
    markAsRead: 'Oznacz jako przeczytane',
    unsubscribe: 'Anuluj subskrypcję',
    subscribe: 'Subskrybuj',
    deleteThread: 'Usuń wątek',
    editComment: 'Edytuj komentarz',
    emptyPlaceholder: 'Przekaż opinię, zadaj pytanie lub zostaw notatkę dla członków zespołu',
    searchPlaceholder: 'Szukaj komentarzy',
    commentPlaceholder: 'Skomentuj {page}',
    replyPlaceholder: 'Odpowiedz....',
    filterPages: 'Strony',
    filterAuthor: 'Autor',
    filterTagged: 'Oznaczeni',
    statusOpen: 'Otwarte',
    statusResolved: 'Rozwiązane',
    anonymous: 'Anonimowy',
    settingsPanel: {
      title: 'Kto może komentować?',
      everyoneLabel: 'Wszyscy',
      restrictedLabel: 'Tylko zaproszeni współpracownicy',
      emailsLabel: 'E-maile',
      emailsPlaceholder: 'Dodaj e-mail i naciśnij Enter',
    },
  },
}
